const has = function(strategyName) {
	return Object.prototype.hasOwnProperty.call(strategies, strategyName);
};

const replaceRamSpeed = function(spec, ramSpeed) {
	// Regex to match the ram speed from a part spec name
	const ramSpeedRegex = /\d+([.|,]\d+)? ?mhz/i;
	return spec.replace(ramSpeedRegex, `${ramSpeed} MHz`);
};

const strategies = {
	ram: {
		get({ parts, name }) {
			const {
				motherboards: { highest_ram_speed: highestRamSpeed },
				[name]: ram
			} = parts;
			const { max_speed: ramSpeed } = ram;

			const ramMaxSpeed = parseInt(ramSpeed);
			const motherboardRamMaxSpeed = parseInt(highestRamSpeed);
			const lowestRamMaxSpeed = (ramMaxSpeed > motherboardRamMaxSpeed) ? motherboardRamMaxSpeed : ramMaxSpeed;

			return {
				...ram,
				max_speed: replaceRamSpeed(ramSpeed, lowestRamMaxSpeed),
				name: replaceRamSpeed(ram.name, lowestRamMaxSpeed),
				product_name: replaceRamSpeed(ram.product_name, lowestRamMaxSpeed),
				short_name: replaceRamSpeed(ram.short_name, lowestRamMaxSpeed),
				title: replaceRamSpeed(ram.title, lowestRamMaxSpeed)
			};
		}
	},
	extras: {
		get({ parts, name }) {
			const part = parts[name];
			return part[0];
		}
	},
	storage: {
		get({ parts, name }) {
			const storageType = "SSD";
			const part = parts[name];
			const drive = part[storageType];
			const [driveId] = Object.keys(drive);
			const storage = drive[driveId];

			const capacity = storage.capacity.replace(/\.\d+\s*/g, "");
			return {
				...storage,
				capacity,
				name: `${capacity} ${storage.name} ${
					storage.form_factor
				} ${storageType}`
			};
		}
	},
	default: {
		get({ parts, name }) {
			return parts[name];
		}
	}
};

export default {
	strategies,
	has
};
